
import styles from './ImageContainer.module.scss';


interface Props  {
url: string,
}

export default function ImageContainer(props:Props)  {
    
const imgContainerHW = window.innerHeight
const variableStyles = {
    width: 0.07*imgContainerHW,
    height: 0.07*imgContainerHW,
}

    return(
        <div className={styles.container} style={variableStyles}>
            <img src={""} />

        </div>
    )
}